// src/cases/CaseNumberInput.js
import React from 'react';
import { TextInput, useRecordContext } from 'react-admin';
import { generateCaseId } from '../utils/caseIdUtils';

/**
 * Custom input component that displays a consistent case number in edit forms
 * Uses the stored caseNumber if available, otherwise falls back to a generated number
 * Always disabled since case numbers should not be editable
 * Format: YYYYMMDDXXXXXXXX (date prefix + 4-digit UID hash + 4-digit NIE hash)
 */
export const CaseNumberInput = ({ source = 'caseNumber', ...props }) => {
    const record = useRecordContext();

    if (!record) return <TextInput source={source} disabled {...props} />;

    // Calculate the display value using the shared utility
    const displayValue = generateCaseId(record);

    // Create a modified record with the display value
    const modifiedRecord = {
        ...record,
        [source]: displayValue
    };

    return (
        <TextInput
            source={source}
            disabled
            record={modifiedRecord}
            {...props}
        />
    );
};

CaseNumberInput.defaultProps = {
    label: 'Case ID',
};
